define([
  "marionette",
  "messaging/messenger",
  "underscore",
  "./topicCopyResponseModalView",
  "./topicCopyResponseSearchTopic/topicCopyResponseSearchTopicModule",
  "./topicCopyResponseLocaleAndTouchpoint/topicCopyResponseLocaleAndTouchpointModule",
], function (
  Marionette,
  Messenger,
  _,
  TopicCopyResponseModalView,
  TopicCopyResponseSearchTopicModule,
  TopicCopyResponseLocaleAndTouchpointModule,
) {
  "use strict";

  const TOPIC_SEARCH_PAGE = 1;
  const LOCALE_AND_TOUCHPOINT_PAGE = 2;

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicCopyResponseModal";
      this.namespace = options.namespace;
      this.namespacePrefix = this.namespace ? this.namespace + ":" : "";
    },
    show: function (dataBundle) {
      this.conversation = dataBundle.conversation;
      this.sourceResponseTemplate = dataBundle.sourceResponseTemplate;
      this.activePageNumber = 1;
      this.touchPoints = Messenger.reqres.request("kb:touchpoints");
      this.locales = Messenger.reqres.request("kb:languages");
      this.layout = new TopicCopyResponseModalView.topicCopyResponseModalLayout();
      this.searchTopicPage = this.addSubModule(
        new TopicCopyResponseSearchTopicModule({ region: this.layout.wizardPage }),
      );
      this.localeAndTouchpointPage = this.addSubModule(
        new TopicCopyResponseLocaleAndTouchpointModule({ region: this.layout.wizardPage }),
      );
      this.layout.on("done", this._onDone, this);
      this.layout.on("cancel", this._onCancel, this);
      this.layout.on("next", this._onNext, this);
      this.layout.on("back", this._onBack, this);
      this.layout.on("show", this.showActivePage, this);
      this.showRegion(this.layout);
    },
    _onCancel: function () {
      this.layout.hideError();
      Messenger.vent.trigger("close:modal");
      Messenger.vent.trigger(this.namespacePrefix + "cancel:copy:responses");
    },
    _onNext: function () {
      if (this.activePageNumber === TOPIC_SEARCH_PAGE) {
        if (this.searchTopicPage.noTopicSelectedCheck()) {
          this.searchTopicPage.showError();
          return;
        }
        this.activePageNumber = LOCALE_AND_TOUCHPOINT_PAGE;
      }
      this.showActivePage();
    },
    _onBack: function () {
      if (this.activePageNumber === LOCALE_AND_TOUCHPOINT_PAGE) {
        this.activePageNumber = TOPIC_SEARCH_PAGE;
      }
      this.searchTopicPage.setSelectedConversation(this.conversation);
      this.showActivePage();
    },
    _onDone: function () {
      this.layout.hideError();
      const selectedResponses = Messenger.reqres.request(this.name + ":treeList:selected:nodes");
      if (selectedResponses.length === 0) {
        this.layout.hideWarning();
        //no responses selected
        this.layout.showError();
        return;
      }
      this.localeAndTouchpointPage.copyResponses(selectedResponses);
      Messenger.vent.trigger("close:modal");
      Messenger.vent.trigger(this.namespacePrefix + "done:copy:responses");
    },
    showActivePage: function () {
      switch (this.activePageNumber) {
        case TOPIC_SEARCH_PAGE:
          this.layout.hideError();
          this.searchTopicPage.show({
            conversation: this.conversation,
            sourceResponseTemplate: this.sourceResponseTemplate,
          });
          this.layout.hideButtons();
          this.layout.showNextButton();
          break;
        case LOCALE_AND_TOUCHPOINT_PAGE:
          this.layout.hideError();
          const selectedConversation = this.searchTopicPage.getConversation();
          this.localeAndTouchpointPage.show({
            conversation: this.conversation,
            sourceResponseTemplate: this.sourceResponseTemplate,
            selectedConversation: selectedConversation,
          });
          this.layout.hideButtons();
          this.layout.showBackButton();
          this.layout.showDoneButton();
          break;
      }
    },
  });
});
